<template>
  <SalesDashboardCard title="Summary" class-card="col-md-8" @set-filter="setFilter" :selected-filter="selectedFilter" :filters="filters">
    <div slot="body">
      <Loader v-if="loading" />
      <template v-else>
        <SummaryChart :data="data" />
      </template>
    </div>
  </SalesDashboardCard>
</template>

<script>
import moment from 'moment';
import axios from 'axios';
import SalesDashboardCard from '../SalesDashboardCard';
import Loader from './Loader';
import SummaryChart from './Summary/SummaryChart';

const filters = [
  {
    name: 'Today',
    to: moment().format('YYYY-MM-DD'),
    from: moment().format('YYYY-MM-DD'),
    year: '',
  },
  {
    name: 'This week',
    date: '',
    from: moment()
      .weekday(1)
      .format('YYYY-MM-DD'),
    to: moment()
      .weekday(7)
      .format('YYYY-MM-DD'),
    year: '',
  },
  {
    name: 'Last week',
    from: moment()
      .subtract(1, 'weeks')
      .weekday(1)
      .format('YYYY-MM-DD'),
    to: moment()
      .subtract(1, 'weeks')
      .weekday(7)
      .format('YYYY-MM-DD'),
    year: '',
  },
  {
    name: 'This month',
    date: '',
    from: moment()
      .startOf('month')
      .format('YYYY-MM-DD'),
    to: moment()
      .endOf('month')
      .format('YYYY-MM-DD'),
    year: '',
  },
  {
    name: 'Monthly this year',
    date: '',
    from: '',
    to: '',
    year: moment().year(),
  },
  {
    name: 'Monthly last year',
    date: '',
    from: '',
    to: '',
    year: moment().year() - 1,
  },
];

export default {
  components: { SummaryChart, Loader, SalesDashboardCard },
  data() {
    return {
      data: [],
      selectedFilter: filters[1],
      filters,
      loading: false,
    };
  },
  watch: {
    selectedFilter() {
      this.getSummary();
    },
  },
  mounted() {
    this.getSummary();
  },
  methods: {
    getSummary() {
      this.loading = true;
      axios
        .get(
          `/sales/summary?date_from=${this.selectedFilter.from}&date_to=${
            this.selectedFilter.to
          }&year=${this.selectedFilter.year}`,
        )
        .then(res => {
          this.data = res.data.data;
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    setFilter(filter) {
      this.selectedFilter = filter;
    },
  },
};
</script>

<style scoped lang="scss">
.legend-wrapper {
  display: flex;
  align-items: center;
  justify-content: flex-start;

  .legend-item {
    display: flex;
    align-items: center;

    .legend-circle {
      width: 10px;
      height: 10px;
      border-radius: 5px;
    }

    .legend-title {
      font-size: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/salesDashboard/subcomponents/cards/Summary.vue